import { ActionForm } from '@pages/EntityCreateOrEdit/components/AddActionDialog/hooks'

import { getStateFromData } from '@components/CommandParameters/helpers'

import { AutocompleteOption, GETShareColumn } from '@types'

import { transformRedefinitionCommandsRequestDataToFormData } from '../helpers'

export type ConvertRowToActionFormInitialValues = {
  currentRow: GETShareColumn
  selectedColumnOptions: AutocompleteOption[]
}

export const convertRowToActionFormInitialValues = (
  data: ConvertRowToActionFormInitialValues
): ActionForm => {
  const { currentRow, selectedColumnOptions } = data

  return {
    ...currentRow,
    params: currentRow.params ? JSON.stringify(currentRow.params) : '',
    order: currentRow.order?.toString(),
    draggableElementText:
      currentRow.draggableElementFieldCode && currentRow.draggableElementFieldTitle
        ? {
            id: currentRow.draggableElementFieldCode,
            label: currentRow.draggableElementFieldTitle,
          }
        : null,
    formObject: currentRow?.objectCode
      ? {
          id: currentRow?.objectCode,
          label: currentRow?.objectTitle as string,
        }
      : null,
    objectFormCode: currentRow?.objectFormCode
      ? {
          id: currentRow?.objectFormCode,
          label: currentRow?.objectFormTitle as string,
        }
      : null,
    json: Boolean(currentRow.params),
    contextMenu: currentRow.contextMenuId
      ? { id: currentRow.contextMenuId, label: currentRow.contextMenuTitle as string }
      : null,
    tooltip: currentRow.objectTooltipId
      ? { id: currentRow.objectTooltipId, label: currentRow.objectTooltipTitle as string }
      : null,
    redefinitionCommands: transformRedefinitionCommandsRequestDataToFormData(
      currentRow.redefinitionCommands
    ),
    targetColumns: selectedColumnOptions,
    columnToSort: null,
    jsValue: currentRow.jsValue || '',
    variable: currentRow?.variable?.id
      ? {
          id: currentRow?.variable?.id,
          label: currentRow?.variable?.title as string,
        }
      : null,
    variableId: currentRow?.variable?.id,
    command: currentRow.command
      ? [
          {
            ...currentRow.command,
            name: {
              id: currentRow.command.name,
              label: currentRow.command.name,
            },
            sourceCommand: {
              id: currentRow.command.objectCode,
              label: currentRow.command.objectTitle,
            },
            sourceType: {
              id: currentRow.command.resource,
              label: currentRow.command.resource,
            },
            type: null,
            parameters: getStateFromData(currentRow.command.parameters),
            body: getStateFromData(currentRow.command.body),
          },
        ]
      : null,
    view: currentRow?.objectViewId
      ? {
          id: currentRow?.objectViewId,
          label: currentRow?.objectViewTitle || '',
          code: currentRow?.objectViewCode,
        }
      : null,
  }
}
